import React from 'react'
import './ui.css'

const VARIANTS = ['primary', 'secondary', 'success', 'danger', 'ghost', 'outline', 'link']

/**
 * Кнопка. Варианты: primary, secondary, success, danger, ghost, outline, link. size: default | sm (DS v2).
 */
function Button ({
  variant = 'primary',
  type = 'button',
  size,
  className = '',
  children,
  ...props
}) {
  const v = VARIANTS.includes(variant) ? variant : 'primary'
  const sm = size === 'sm' ? ' ui-btn-sm' : ''
  return (
    <button
      type={type}
      className={`ui-btn ui-btn-${v}${sm}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
